module.exports = __webpack_public_path__ + "static/media/phila_quri.e7ca74d3.webp";